// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"96f1ab48","885":"1f24df1f"}[chunkId] + ".chunk.js";
};